import { render, staticRenderFns } from "./PromoProductsResume.vue?vue&type=template&id=093f296e&"
import script from "./PromoProductsResume.vue?vue&type=script&lang=js&"
export * from "./PromoProductsResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports